export function createMeshLabelOverlay() {
  return class MeshLabelOverlay extends google.maps.OverlayView {
    constructor(options) {
      super();
      this.position = options.position;
      this.map = options.map;
      this.content = options.content || "";
      this.className = options.className || "mesh-label";
      this.div = null;

      this.setMap(this.map);
    }

    onAdd() {
      this.div = document.createElement("div");
      this.div.className = this.className;
      this.div.innerHTML = this.content;

      this.div.style.position = "absolute";
      this.div.style.transform = "translate(-50%, -50%)";
      this.div.style.pointerEvents = "none";

      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(this.div);
    }

    draw() {
      const projection = this.getProjection();
      const position = projection.fromLatLngToDivPixel(this.position);

      if (this.div) {
        this.div.style.left = position.x + "px";
        this.div.style.top = position.y + "px";
      }
    }

    onRemove() {
      if (this.div) {
        this.div.remove();
        this.div = null;
      }
    }
  };
}
